var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { getInitialWidgetConfig } from '../widget-config/initial-config';
import { last } from 'lodash';
var WidgetConfigResolver = /** @class */ (function () {
    function WidgetConfigResolver() {
    }
    WidgetConfigResolver.prototype.resolve = function (route) {
        var params = __assign({}, route.queryParams);
        // sanitize the possibility of the same param being included more than once.
        // i.e. &ui-info=false&ui-info=true
        // Rule: take the first one.
        var dedupedParams = Object.keys(params).reduce(function (acc, param) {
            var hasDuplicate = Array.isArray(params[param]);
            acc[param] = hasDuplicate ? last(params[param]) : params[param];
            return acc;
        }, {});
        return getInitialWidgetConfig(dedupedParams);
    };
    return WidgetConfigResolver;
}());
export { WidgetConfigResolver };
